import ChannelUtils from '@shared/utils/channels';
import DetailUtils from '@shared/utils/detail';
import Event from '@shared/classes/event';
import Modals from '@shared/types/enums/modals';
import Rail from '@shared/classes/rail';
import TDetail from '../templates/detail';
import TranslationManager from '@shared/assets/locale/translationsManager';
import detailRequest from '@shared/api/detail/detailRequest';
import { loginAction } from '@shared/actions/flow';
import { routerSelector } from '@shared/store/slices/router.slice';
import { setModal, setModalParams } from '@shared/store/slices/modal.slice';
import { useAppDispatch, useAppSelector } from '@shared/store/hooks';
import { useEffect, useMemo, useState } from 'react';
import { userSelector } from '@shared/store/slices/user.slice';

const LITERALS = 'PAGES.DETAIL';

function Detail() {
  const dispatch = useAppDispatch();
  const {
    params: { current: currentParams },
  } = useAppSelector(routerSelector);
  const { isAnonymous } = useAppSelector(userSelector);

  const [complete, setComplete] = useState(false);
  const [asset, setAsset] = useState<Event>(currentParams?.asset as Event);
  const [related, setRelated] = useState<Rail | null>(null);
  const [reset, setReset] = useState(false);

  // Detail data

  const { buttons, synopsis, upgradablePlan } = useMemo(() => {
    const upgradablePlan = ChannelUtils.getUpgradablePlan(
      asset?.channel,
      false,
      asset?.type
    );
    const synopsis = DetailUtils.separateSynopsis(asset?.synopsis || '');
    const buttons = upgradablePlan
      ? isAnonymous
        ? [
            {
              title: TranslationManager.get(`${LITERALS}.BUTTONS.SUBSCRIBE`),
              action: () => {
                dispatch(setModal(Modals.ANONYMOUS_GENERIC));
              },
            },
            {
              title: TranslationManager.get(`${LITERALS}.BUTTONS.LOGIN`),
              action: () => {
                loginAction();
              },
            },
          ]
        : [
            {
              title: TranslationManager.get(
                `${LITERALS}.BUTTONS.WANT_TO_WATCH`
              ),
              action: () => {
                dispatch(
                  setModalParams({
                    plan: upgradablePlan,
                    channel: asset?.channel,
                  })
                );
                dispatch(setModal(Modals.UPGRADE_PLAN));
              },
            },
          ]
      : [];

    return {
      buttons,
      synopsis,
      upgradablePlan,
    };
  }, [asset, isAnonymous]);

  // Effect hooks

  useEffect(() => {
    detailRequest(
      (currentParams?.asset as Event)?.id,
      (currentParams?.asset as Event)?.eventId
    ).then((item) => {
      if (item?.rail?.data?.length) {
        setRelated(item?.rail);
      }
      if (item?.asset) {
        setAsset(item?.asset);
      }
      setComplete(true);
    });
  }, [currentParams]);

  useEffect(() => {
    if (currentParams?.asset) {
      setReset(true);
      setComplete(false);
      setAsset(currentParams?.asset as Event);
      setTimeout(() => {
        setReset(false);
      });
    }
  }, [currentParams]);

  return !reset ? (
    <TDetail
      asset={asset}
      buttons={buttons}
      complete={complete}
      related={related}
      synopsis={synopsis}
      upgradablePlan={upgradablePlan}
    />
  ) : null;
}

export default Detail;
